import React from "react";

const Checkboxes = ({ type = "v1", label, reqd, data, values, click }) => {
  const labels = data.map((item, index) => {
    return type === "v1" ? (
      <label key={index}>
        <input
          type="checkbox"
          name={item.name}
          value={item.val}
          defaultChecked={item.val}
          onClick={(e) => click(item.name, e.target.checked)}
        />
        <span>{item.label ? item.label : item.val}</span>
      </label>
    ) : (
      <label key={index}>
        <input
          type="checkbox"
          name={item.name}
          value={item.val}
          defaultChecked={values.includes(item.val)}
          onClick={(e) => click(item.name, e.target.checked, e.target.value)}
        />
        <span>{item.label ? item.label : item.val}</span>
      </label>
    );
  });

  return (
    <div>
      <label>
        {label} {reqd && <span className="reqd">*</span>}
      </label>
      <div>{labels}</div>
    </div>
  );
};

export default Checkboxes;
